import {
  ReconnectingWebSocket
} from "./chunk-YV734IKE.mjs";

// src/use-ws.ts
import { useEffect, useRef, useState } from "react";
function useWebSocket(url, protocols, options) {
  const [startClosed] = useState(options?.startClosed || false);
  const { onOpen, onMessage, onClose, onError, ...webSocketOptions } = options || {};
  const socketRef = useRef(
    new ReconnectingWebSocket(url, protocols, {
      ...webSocketOptions,
      startClosed: true
      // only connect on mount
    })
  );
  useEffect(() => {
    const socket = socketRef.current;
    if (onOpen)
      socket.addEventListener("open", onOpen);
    if (onClose)
      socket.addEventListener("close", onClose);
    if (onError)
      socket.addEventListener("error", onError);
    if (onMessage)
      socket.addEventListener("message", onMessage);
    return () => {
      if (onOpen)
        socket.removeEventListener("open", onOpen);
      if (onClose)
        socket.removeEventListener("close", onClose);
      if (onError)
        socket.removeEventListener("error", onError);
      if (onMessage)
        socket.removeEventListener("message", onMessage);
    };
  }, [onOpen, onMessage, onClose, onError]);
  useEffect(() => {
    const socket = socketRef.current;
    if (startClosed !== true) {
      socket.reconnect();
    }
    return () => {
      socket.close();
    };
  }, [startClosed]);
  return socketRef.current;
}

export {
  useWebSocket
};
